angular
  .module('zc.core')
  .component('zcTosNotification', {
    templateUrl: '/templates/core/components/tos_notification/tos_notification.html',
    bindings: {
      serviceName: '@',
      tosUrl: '@',
      updatedAt: '@',
    },
    controller: zcTosNotification,
    controllerAs: 'vm'
  });

zcTosNotification.$inject = ['Devise'];
function zcTosNotification(Devise) {
  const vm = this;

  vm.$onInit = () => {
    vm.isTosSigned = true;
    vm.user = {};

    Devise.getCurrentUser().then(user => {
      vm.user = user;
      vm.isTosSigned = user.agreement_2020_signed_at !== null;
    });
  };

  vm.signAgreements = () => {
    Devise.getCurrentUser().then(user => {
      Devise.signAgreements(user).then(() => {
        vm.isTosSigned = true;
      });
    });
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/components/tos_notification/tos_notification.js